require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-increase-your-average-order-value.json") })
        }
      }, "path---tapd-in-increase-your-average-order-value");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-increase-your-average-order-value!./.cache/json/tapd-in-increase-your-average-order-value.json
// module id = 854
// module chunks = 231608221292675